export interface TipoConta {
  id: number;
  nome: string;
}

export enum TipoContaId {
  RECEBER = 1,
  PAGAR = 2
}

export interface Categoria {
  id: number;
  tipo_conta_id: number;
  nome: string;
}

export interface FormaPagamento {
  id: number;
  nome: string;
}

export interface Banco {
  id: number;
  nome?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  deleted_at?: string | null;
}

export interface DadosBancarios {
  id: number;
  pessoa_id: number;
  forma_pagamento_id: number;
  banco_id: number;
  conta?: string | null;
  agencia?: string | null;
  nome?: string | null;
  cpf?: string | null;
  pix?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  deleted_at?: string | null;
}

export interface GatewayPagamento {
  id: number;
  nome: string;
  access_token?: string | null;
  client_secret?: string | null;
  client_id?: string | null;
  oauth_token?: string | null;
  oauth_token_created_at?: string | null;
  certificado_crt?: string | null;
  certificado_key?: string | null;
  webhook_url?: string | null;
  webhook_certificado_cert?: string | null;
}

export interface FormaPagamentoGateway {
  id: number;
  forma_pagamento_id: number;
  gateway_pagamento_id: number;
}

export interface StatusCobranca {
  id: number;
  nome: string;
  cor: string;
}

export interface StatusCobrancaGatewayPagamento {
  id: number;
  gateway_pagamento_id: number;
  status_cobranca_id: number;
  codigo: string;
}

export interface Conta {
  id: number;
  tipo_conta_id: number;
  pessoa_id: number;
  medicoes_id?: number | null;
  medicoes_agregado_id?: number | null;
  forma_pagamento_id: number;
  categoria_id?: number | null;
  pedido_venda_id?: number | null;
  gateway_pagamento_id?: number | null;
  descricao?: string | null;
  dt_vencimento?: string | null;
  valor: number;
  dt_emissao?: string | null;
  dt_pagamento?: string | null;
  parcela?: number | null;
  obs?: string | null;
  mes_vencimento?: number | null;
  ano_vencimento?: number | null;
  ano_mes_vencimento?: number | null;
  mes_emissao?: number | null;
  ano_emissao?: number | null;
  ano_mes_emissao?: number | null;
  mes_pagamento?: number | null;
  ano_pagamento?: number | null;
  ano_mes_pagamento?: number | null;
  created_at?: string | null;
  updated_at?: string | null;
  deleted_at?: string | null;

  // Extended UI / Helper properties
  numero_nf?: string | null;
  comprovante_url?: string | null;
  comprovante_nome?: string | null;
  boleto_url?: string | null;
  boleto_nome?: string | null;
  nf_url?: string | null;
  nf_nome?: string | null;
  anexos_count?: number;
  anexos?: ContaAnexo[];
  valor_pago?: number | null;
  juros_multa?: number | null;
  desconto?: number | null;
  banco_id?: number | null;
  banco_nome?: string | null;
  cnpj_faturador?: string | null;
  empresa_faturadora?: string | null;
}

export enum TipoAnexoId {
  RECIBO = 1,
  BOLETO = 2,
  NOTA_FISCAL = 3,
  FATURA = 4,
  COMPROVANTE = 5,
  BM = 6,
  OUTROS = 7
}

export interface BaixaPagamentoPayload {
  conta_id: number;
  dt_pagamento: string;
  valor_pago?: number;
  forma_pagamento_id?: number;
  banco_id?: number;
  banco_nome?: string;
  cnpj_faturador?: string;
  empresa_faturadora?: string;
  comprovante_url?: string;
  comprovante_nome?: string;
  boleto_url?: string;
  boleto_nome?: string;
  nf_url?: string;
  nf_nome?: string;
  novos_anexos?: Array<{ tipo_anexo_id: number; descricao: string; arquivo: string }>;
  observacao_baixa?: string;
  numero_nf?: string;
}

export interface TipoAnexo {
  id: number;
  nome: string;
}

export interface ContaAnexo {
  id?: number;
  conta_id: number;
  tipo_anexo_id: number;
  descricao?: string | null;
  arquivo?: string | null;
  tipo_anexo?: TipoAnexo;
  created_at?: string | null;
}

export interface Cobranca {
  id: string;
  conta_id: number;
  status_cobranca_id: number;
  gateway_pagamento_id: number;
  codigo?: string | null;
  link?: string | null;
  data_pagamento?: string | null;
  valor_total?: string | null;
}
